import React from "react";

export const ICON_DTP = {
  arrowDown: (
     <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
       <g clipPath="url(#clip0_11818_15064)">
         <path d="M12.3346 7.1665L8.0013 11.4998L3.66797 7.1665" stroke="#191D32" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
         <path d="M12.3346 7.1665L8.0013 11.4998L3.66797 7.1665" stroke="#F4F7FC" strokeOpacity="0.4" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
       </g>
       <defs>
         <clipPath id="clip0_11818_15064">
           <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
         </clipPath>
       </defs>
     </svg>
  ),
  trash: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7444 15.0296L16.7444 15.0385L15.7444 15.0296ZM3.33398 3.99984C2.7817 3.99984 2.33398 4.44755 2.33398 4.99984C2.33398 5.55212 2.7817 5.99984 3.33398 5.99984V3.99984ZM16.6673 5.99984C17.2196 5.99984 17.6673 5.55212 17.6673 4.99984C17.6673 4.44755 17.2196 3.99984 16.6673 3.99984V5.99984ZM9.33398 8.33317C9.33398 7.78089 8.88627 7.33317 8.33398 7.33317C7.7817 7.33317 7.33398 7.78089 7.33398 8.33317H9.33398ZM7.33398 14.9998C7.33398 15.5521 7.7817 15.9998 8.33398 15.9998C8.88627 15.9998 9.33398 15.5521 9.33398 14.9998H7.33398ZM12.6673 8.33317C12.6673 7.78089 12.2196 7.33317 11.6673 7.33317C11.115 7.33317 10.6673 7.78089 10.6673 8.33317H12.6673ZM10.6673 14.9998C10.6673 15.5521 11.115 15.9998 11.6673 15.9998C12.2196 15.9998 12.6673 15.5521 12.6673 14.9998H10.6673ZM14.834 4.99091L14.7445 15.0207L16.7444 15.0385L16.8339 5.00877L14.834 4.99091ZM12.4112 17.3332H7.50065V19.3332H12.4112V17.3332ZM3.16732 4.99984V14.9998H5.16732V4.99984H3.16732ZM3.33398 5.99984H4.16732V3.99984H3.33398V5.99984ZM4.16732 5.99984H6.66732V3.99984H4.16732V5.99984ZM6.66732 5.99984H13.334V3.99984H6.66732V5.99984ZM13.334 5.99984H15.834V3.99984H13.334V5.99984ZM15.834 5.99984H16.6673V3.99984H15.834V5.99984ZM7.66732 4.62947C7.66732 3.65283 8.59801 2.6665 10.0007 2.6665V0.666504C7.7214 0.666504 5.66732 2.33331 5.66732 4.62947H7.66732ZM10.0007 2.6665C11.4033 2.6665 12.334 3.65283 12.334 4.62947H14.334C14.334 2.33331 12.2799 0.666504 10.0007 0.666504V2.6665ZM5.66732 4.62947V4.99984H7.66732V4.62947H5.66732ZM12.334 4.62947V4.99984H14.334V4.62947H12.334ZM7.50065 17.3332C6.21199 17.3332 5.16732 16.2885 5.16732 14.9998H3.16732C3.16732 17.3931 5.10742 19.3332 7.50065 19.3332V17.3332ZM14.7445 15.0207C14.733 16.3012 13.6918 17.3332 12.4112 17.3332V19.3332C14.7894 19.3332 16.7232 17.4166 16.7444 15.0385L14.7445 15.0207ZM7.33398 8.33317V14.9998H9.33398V8.33317H7.33398ZM10.6673 8.33317V14.9998H12.6673V8.33317H10.6673Z"
        fill="#DA3737"
      />
    </svg>
  ),
  account: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9604 14.052C15.5814 13.1543 15.0315 12.3389 14.3412 11.6513C13.653 10.9616 12.8377 10.4118 11.9405 10.0321C11.9325 10.0281 11.9244 10.0261 11.9164 10.022C13.1679 9.11803 13.9816 7.64548 13.9816 5.9841C13.9816 3.23186 11.7517 1.00195 8.99942 1.00195C6.24719 1.00195 4.01728 3.23186 4.01728 5.9841C4.01728 7.64548 4.8309 9.11803 6.08246 10.0241C6.07442 10.0281 6.06639 10.0301 6.05835 10.0341C5.15835 10.4138 4.35076 10.9582 3.65768 11.6533C2.96804 12.3415 2.41818 13.1567 2.03848 14.054C1.66547 14.9324 1.4643 15.8741 1.44585 16.8283C1.44531 16.8497 1.44908 16.8711 1.45691 16.891C1.46475 16.911 1.4765 16.9292 1.49148 16.9445C1.50646 16.9599 1.52435 16.9721 1.54412 16.9804C1.56389 16.9887 1.58512 16.993 1.60657 16.993H2.81192C2.90032 16.993 2.97063 16.9227 2.97264 16.8363C3.01282 15.2854 3.63558 13.833 4.73648 12.7321C5.87554 11.593 7.38826 10.9662 8.99942 10.9662C10.6106 10.9662 12.1233 11.593 13.2624 12.7321C14.3633 13.833 14.986 15.2854 15.0262 16.8363C15.0282 16.9247 15.0985 16.993 15.1869 16.993H16.3923C16.4137 16.993 16.435 16.9887 16.4547 16.9804C16.4745 16.9721 16.4924 16.9599 16.5074 16.9445C16.5223 16.9292 16.5341 16.911 16.5419 16.891C16.5498 16.8711 16.5535 16.8497 16.553 16.8283C16.5329 15.868 16.334 14.9339 15.9604 14.052ZM8.99942 9.43946C8.07732 9.43946 7.20947 9.07986 6.55657 8.42695C5.90366 7.77405 5.54407 6.9062 5.54407 5.9841C5.54407 5.062 5.90366 4.19414 6.55657 3.54124C7.20947 2.88834 8.07732 2.52874 8.99942 2.52874C9.92152 2.52874 10.7894 2.88834 11.4423 3.54124C12.0952 4.19414 12.4548 5.062 12.4548 5.9841C12.4548 6.9062 12.0952 7.77405 11.4423 8.42695C10.7894 9.07986 9.92152 9.43946 8.99942 9.43946Z"
        fill="#3264FF"
      />
    </svg>
  ),
  info: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.29492 6C1.29492 3.04289 3.71282 0.625 6.66992 0.625C9.62703 0.625 12.0449 3.04289 12.0449 6C12.0449 8.95711 9.62703 11.375 6.66992 11.375C3.71282 11.375 1.29492 8.95711 1.29492 6ZM6.66992 1.375C4.12703 1.375 2.04492 3.45711 2.04492 6C2.04492 8.54289 4.12703 10.625 6.66992 10.625C9.21282 10.625 11.2949 8.54289 11.2949 6C11.2949 3.45711 9.21282 1.375 6.66992 1.375Z"
        fill="#3264FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66992 8.5C6.46281 8.5 6.29492 8.33211 6.29492 8.125L6.29492 5.625C6.29492 5.41789 6.46282 5.25 6.66992 5.25C6.87703 5.25 7.04492 5.41789 7.04492 5.625L7.04492 8.125C7.04492 8.33211 6.87703 8.5 6.66992 8.5Z"
        fill="#3264FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.17188 4.125C7.17188 4.40114 6.94802 4.625 6.67188 4.625L6.66738 4.625C6.39124 4.625 6.16738 4.40114 6.16738 4.125C6.16738 3.84886 6.39124 3.625 6.66738 3.625L6.67188 3.625C6.94802 3.625 7.17188 3.84886 7.17188 4.125Z"
        fill="#3264FF"
      />
    </svg>
  ),
  private: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5566_58866)">
        <path
          d="M15.4281 0H2.57096C2.21538 0 1.9281 0.287277 1.9281 0.642857V17.3571C1.9281 17.7127 2.21538 18 2.57096 18H15.4281C15.7837 18 16.071 17.7127 16.071 17.3571V0.642857C16.071 0.287277 15.7837 0 15.4281 0ZM10.2049 1.44643H12.1335V5.66317L11.1993 4.98214L10.2049 5.6933V1.44643ZM14.6245 16.5536H3.37453V1.44643H8.99953V7.41094C8.99953 7.47723 9.01962 7.54353 9.0598 7.59777C9.08419 7.63225 9.11517 7.66154 9.15096 7.68397C9.18674 7.70639 9.22662 7.7215 9.26828 7.72841C9.30994 7.73532 9.35256 7.73391 9.39368 7.72424C9.43479 7.71457 9.47357 7.69685 9.50779 7.6721L11.1913 6.46875L12.8265 7.66205C12.8808 7.70223 12.9471 7.72433 13.0154 7.72433C13.1922 7.72433 13.3368 7.57969 13.3368 7.4029V1.44643H14.6225V16.5536H14.6245Z"
          fill="#3264FF"
          fill-opacity="0.85"
        />
      </g>
      <defs>
        <clipPath id="clip0_5566_58866">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  orderInfo: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5362 4.97838V4.01409C12.5362 3.9257 12.4639 3.85338 12.3755 3.85338H4.66119C4.57279 3.85338 4.50047 3.9257 4.50047 4.01409V4.97838C4.50047 5.06677 4.57279 5.13909 4.66119 5.13909H12.3755C12.4639 5.13909 12.5362 5.06677 12.5362 4.97838ZM4.66119 6.74623C4.57279 6.74623 4.50047 6.81856 4.50047 6.90695V7.87123C4.50047 7.95963 4.57279 8.03195 4.66119 8.03195H8.35761C8.44601 8.03195 8.51833 7.95963 8.51833 7.87123V6.90695C8.51833 6.81856 8.44601 6.74623 8.35761 6.74623H4.66119ZM12.2148 9.07659C9.81811 9.07659 7.87547 11.0192 7.87547 13.4159C7.87547 15.8125 9.81811 17.7552 12.2148 17.7552C14.6114 17.7552 16.554 15.8125 16.554 13.4159C16.554 11.0192 14.6114 9.07659 12.2148 9.07659ZM14.3744 15.5755C13.7978 16.152 13.0304 16.4694 12.2148 16.4694C11.3991 16.4694 10.6317 16.152 10.0552 15.5755C9.4786 14.9989 9.16119 14.2315 9.16119 13.4159C9.16119 12.6003 9.4786 11.8328 10.0552 11.2563C10.6317 10.6797 11.3991 10.3623 12.2148 10.3623C13.0304 10.3623 13.7978 10.6797 14.3744 11.2563C14.9509 11.8328 15.2683 12.6003 15.2683 13.4159C15.2683 14.2315 14.9509 14.9989 14.3744 15.5755ZM14.0027 11.8891H13.1127C13.0605 11.8891 13.0123 11.9132 12.9822 11.9554L11.7065 13.7192L11.2424 13.0784C11.2276 13.0577 11.208 13.0408 11.1852 13.0293C11.1625 13.0178 11.1373 13.0119 11.1119 13.0121H10.2259C10.0953 13.0121 10.019 13.1607 10.0953 13.2672L11.5779 15.3183C11.6422 15.4067 11.7728 15.4067 11.8371 15.3183L14.1313 12.1442C14.2096 12.0378 14.1333 11.8891 14.0027 11.8891ZM7.55404 15.8266H2.89333V1.68373H14.1433V8.59445C14.1433 8.68284 14.2157 8.75516 14.304 8.75516H15.429C15.5174 8.75516 15.5898 8.68284 15.5898 8.59445V0.880162C15.5898 0.524581 15.3025 0.237305 14.9469 0.237305H2.08976C1.73418 0.237305 1.4469 0.524581 1.4469 0.880162V16.6302C1.4469 16.9857 1.73418 17.273 2.08976 17.273H7.55404C7.64244 17.273 7.71476 17.2007 7.71476 17.1123V15.9873C7.71476 15.8989 7.64244 15.8266 7.55404 15.8266Z"
        fill="#3264FF"
      />
    </svg>
  ),
  notiStatus: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1071 14.1403H14.625V7.30999C14.625 4.47539 12.5297 2.13298 9.80357 1.74325V0.961775C9.80357 0.517801 9.44397 0.158203 9 0.158203C8.55603 0.158203 8.19643 0.517801 8.19643 0.961775V1.74325C5.47031 2.13298 3.375 4.47539 3.375 7.30999V14.1403H2.89286C2.53728 14.1403 2.25 14.4276 2.25 14.7832V15.4261C2.25 15.5145 2.32232 15.5868 2.41071 15.5868H6.75C6.75 16.8283 7.75848 17.8368 9 17.8368C10.2415 17.8368 11.25 16.8283 11.25 15.5868H15.5893C15.6777 15.5868 15.75 15.5145 15.75 15.4261V14.7832C15.75 14.4276 15.4627 14.1403 15.1071 14.1403ZM9 16.5511C8.46763 16.5511 8.03571 16.1191 8.03571 15.5868H9.96429C9.96429 16.1191 9.53237 16.5511 9 16.5511ZM4.82143 14.1403V7.30999C4.82143 6.19303 5.25536 5.14436 6.04487 4.35486C6.83438 3.56535 7.88304 3.13142 9 3.13142C10.117 3.13142 11.1656 3.56535 11.9551 4.35486C12.7446 5.14436 13.1786 6.19303 13.1786 7.30999V14.1403H4.82143Z"
        fill="#3264FF"
        fill-opacity="0.85"
      />
    </svg>
  ),
  digital: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.948242" width="20" height="20" rx="10" fill="#FF9F41" />
      <path
        d="M11.1473 14.6809H5.79353C5.53386 14.6809 5.32335 14.8865 5.32335 15.1401C5.32335 15.3937 5.53386 15.5993 5.79353 15.5993H11.1473C11.4069 15.5993 11.6174 15.3937 11.6174 15.1401C11.6174 14.8865 11.4069 14.6809 11.1473 14.6809Z"
        fill="white"
      />
      <path
        d="M14.7519 8.70538V8.17273C14.7526 7.51741 14.2249 6.97773 13.5546 6.94824H5.1917C4.8669 6.95463 4.55821 7.08767 4.33445 7.31769C4.1107 7.54772 3.99048 7.85561 4.00059 8.17273V12.4584C3.99975 13.1115 4.52384 13.6503 5.1917 13.6829H11.7616V9.87477C11.765 9.23033 12.2991 8.70873 12.959 8.70538H14.7519Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1972 9.21355H15.0779C15.3307 9.22154 15.5698 9.32733 15.7427 9.50762C15.9155 9.68792 16.0079 9.92792 15.9995 10.1748V14.987C16.0079 15.2339 15.9155 15.4739 15.7427 15.6542C15.5698 15.8345 15.3307 15.9403 15.0779 15.9482H13.1972C12.6699 15.9316 12.2553 15.5021 12.2694 14.987V10.1748C12.2588 9.66096 12.6714 9.23347 13.1972 9.21355ZM13.8367 14.9013C13.8367 15.0704 13.977 15.2074 14.1501 15.2074C14.3232 15.2074 14.4636 15.0704 14.4636 14.9013C14.4636 14.7322 14.3232 14.5952 14.1501 14.5952C13.9784 14.5984 13.84 14.7336 13.8367 14.9013Z"
        fill="white"
      />
    </svg>
  ),
  book: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.948242" width="20" height="20" rx="10" fill="#00AB56" />
      <path
        d="M15 13.0602V7.51967C15 6.09951 13.9674 4.94824 12.6937 4.94824H7.30627C6.03255 4.94824 5 6.09951 5 7.51967V14.7471C5 15.9628 5.88387 16.9482 6.97417 16.9482H14.5387C14.7935 16.9482 15 16.718 15 16.434C15 16.1499 14.7935 15.9197 14.5387 15.9197H6.97417C6.39335 15.9197 5.92251 15.3947 5.92251 14.7471C5.92251 14.0995 6.39335 13.5745 6.97417 13.5745H14.5387C14.7935 13.5745 15 13.3443 15 13.0602Z"
        fill="white"
      />
      <path
        d="M6.97417 14.2328C6.71942 14.2328 6.51291 14.4631 6.51291 14.7471C6.51291 15.0311 6.71942 15.2614 6.97417 15.2614H13.7823C14.037 15.2614 14.2435 15.0311 14.2435 14.7471C14.2435 14.4631 14.037 14.2328 13.7823 14.2328H6.97417Z"
        fill="white"
      />
    </svg>
  ),
  copy: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9686 15.7699C2.66085 15.7699 2.39399 15.6569 2.16803 15.4309C1.94208 15.205 1.8291 14.9381 1.8291 14.6304V4.61622H2.9686V14.6304H10.8327V15.7699H2.9686ZM5.10412 13.6304C4.79746 13.6304 4.53155 13.5178 4.30637 13.2926C4.08119 13.0674 3.9686 12.8015 3.9686 12.4948V3.23325C3.9686 2.92549 4.08119 2.65864 4.30637 2.43268C4.53155 2.20673 4.79746 2.09375 5.10412 2.09375H12.3657C12.6735 2.09375 12.9403 2.20673 13.1663 2.43268C13.3922 2.65864 13.5052 2.92549 13.5052 3.23325V12.4948C13.5052 12.8015 13.3922 13.0674 13.1663 13.2926C12.9403 13.5178 12.6735 13.6304 12.3657 13.6304H5.10412ZM5.10412 12.4948H12.3657V3.23325H5.10412V12.4948Z"
        fill="#3264FF"
      />
    </svg>
  ),
  successCircle: (
    <svg
      width="165"
      height="120"
      viewBox="0 0 165 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="77.9932"
        cy="61.0879"
        r="37.5"
        stroke="#F2F2F2"
        strokeWidth="5"
      />
      <path
        d="M62.8818 57.0879L74.5518 71.0879L97.8818 43.0879"
        stroke="#3264FF"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter0_d_4528_37447)">
        <path
          d="M55.3485 46.5834C55.159 45.7704 54.2753 45.3913 53.6217 45.8427L51.4586 47.3364C51.2505 47.4801 51.003 47.5461 50.7543 47.5243L48.1693 47.2975C47.3881 47.2289 46.7875 48.004 46.9957 48.812L47.6844 51.4859C47.7506 51.7432 47.7359 52.0155 47.6425 52.2609L46.6719 54.8111C46.3786 55.5818 46.8911 56.4398 47.6733 56.4878L50.262 56.6467C50.5111 56.662 50.7495 56.7643 50.9405 56.9378L52.9256 58.7407C53.5255 59.2856 54.4428 59.0408 54.7182 58.2625L55.6294 55.6867C55.717 55.4389 55.8791 55.2298 56.0905 55.0916L58.288 53.6557C58.9521 53.2218 59.0066 52.2125 58.3945 51.6834L56.3689 49.9326C56.174 49.7642 56.0358 49.5326 55.9754 49.2738L55.3485 46.5834Z"
          fill="#1FE4FF"
        />
        <path
          d="M16.156 66.7803C15.8911 65.6438 14.6559 65.114 13.7422 65.7449L10.7187 67.8328C10.4277 68.0337 10.0818 68.126 9.73409 68.0955L6.12066 67.7785C5.0287 67.6826 4.18916 68.766 4.48009 69.8956L5.44279 73.6333C5.53542 73.9929 5.51487 74.3736 5.38433 74.7166L4.02754 78.2814C3.61752 79.3586 4.33387 80.558 5.42738 80.6252L9.04593 80.8473C9.39409 80.8687 9.72738 81.0117 9.99437 81.2541L12.7693 83.7744C13.6078 84.536 14.8901 84.1939 15.275 83.1058L16.5487 79.5054C16.6712 79.159 16.8977 78.8666 17.1933 78.6735L20.2651 76.6663C21.1933 76.0598 21.2695 74.6489 20.4138 73.9093L17.5825 71.462C17.31 71.2265 17.1168 70.9029 17.0324 70.5411L16.156 66.7803Z"
          fill="#FF3C11"
        />
        <path
          d="M108.532 90.1917C108.146 90.168 107.846 90.5669 107.946 90.9712L108.278 92.3092C108.31 92.4379 108.302 92.5753 108.255 92.7003L107.766 93.9988C107.619 94.3913 107.87 94.8166 108.256 94.83L109.537 94.8743C109.66 94.8785 109.778 94.9268 109.872 95.0116L110.848 95.8927C111.143 96.159 111.598 96.023 111.737 95.6269L112.196 94.3163C112.24 94.1902 112.321 94.0826 112.426 94.0101L113.518 93.2561C113.848 93.0282 113.878 92.5188 113.577 92.2607L112.581 91.4064C112.485 91.3242 112.417 91.2094 112.388 91.0798L112.087 89.7327C111.996 89.3256 111.56 89.1468 111.235 89.3833L110.159 90.1659C110.056 90.2412 109.933 90.2779 109.81 90.2703L108.532 90.1917Z"
          fill="#FF258E"
        />
        <path
          d="M106.802 44.6176C106.269 44.5849 105.856 45.1351 105.994 45.6929L106.452 47.5385C106.496 47.7161 106.485 47.9057 106.42 48.0781L105.746 49.8694C105.543 50.4107 105.889 50.9974 106.422 51.0159L108.189 51.077C108.358 51.0829 108.521 51.1494 108.65 51.2664L109.997 52.4819C110.404 52.8492 111.032 52.6616 111.223 52.1152L111.857 50.3073C111.917 50.1334 112.029 49.9849 112.174 49.8848L113.68 48.8448C114.136 48.5304 114.177 47.8278 113.762 47.4717L112.387 46.2932C112.255 46.1798 112.162 46.0215 112.122 45.8427L111.706 43.9844C111.58 43.4228 110.979 43.1762 110.53 43.5024L109.047 44.582C108.905 44.6858 108.735 44.7365 108.566 44.726L106.802 44.6176Z"
          fill="#FFE925"
        />
        <path
          d="M21.2135 101.998C21.0871 101.99 20.989 102.121 21.0219 102.253L21.1305 102.691C21.141 102.733 21.1383 102.778 21.1229 102.819L20.963 103.244C20.9147 103.372 20.9968 103.511 21.1234 103.516L21.5424 103.53C21.5827 103.532 21.6212 103.548 21.6519 103.575L21.9714 103.864C22.068 103.951 22.2168 103.906 22.2622 103.777L22.4125 103.348C22.427 103.307 22.4534 103.271 22.4878 103.248L22.8452 103.001C22.9532 102.926 22.9631 102.76 22.8645 102.675L22.5384 102.396C22.507 102.369 22.4849 102.331 22.4754 102.289L22.3768 101.848C22.3469 101.715 22.2043 101.656 22.0979 101.734L21.7461 101.99C21.7123 102.014 21.6721 102.026 21.6319 102.024L21.2135 101.998Z"
          fill="white"
        />
        <path
          d="M99.7406 18.2526C98.8786 18.1799 98.2286 19.045 98.4703 19.9432L99.2702 22.9153C99.3472 23.2013 99.3351 23.5043 99.236 23.7778L98.2052 26.6198C97.8937 27.4787 98.4716 28.4311 99.3345 28.481L102.19 28.646C102.465 28.6618 102.729 28.7745 102.942 28.9667L105.158 30.9638C105.827 31.5673 106.834 31.2907 107.126 30.4234L108.091 27.5532C108.184 27.2771 108.359 27.0436 108.59 26.889L110.99 25.2812C111.715 24.7953 111.76 23.672 111.077 23.0861L108.818 21.1472C108.6 20.9607 108.445 20.7037 108.374 20.4159L107.642 17.4252C107.421 16.5214 106.441 16.1037 105.728 16.6089L103.366 18.2808C103.139 18.4417 102.868 18.5163 102.593 18.4931L99.7406 18.2526Z"
          fill="#FF258E"
        />
        <path
          d="M33.0729 90.5394C32.6866 90.5156 32.3869 90.9145 32.4872 91.3188L32.8193 92.6568C32.8512 92.7856 32.843 92.923 32.796 93.0479L32.3074 94.3465C32.1598 94.7389 32.4105 95.1642 32.7975 95.1776L34.0779 95.2219C34.2011 95.2262 34.3187 95.2745 34.4126 95.3592L35.389 96.2404C35.6841 96.5066 36.1388 96.3706 36.2776 95.9746L36.7369 94.664C36.7811 94.5379 36.8619 94.4303 36.967 94.3577L38.0591 93.6037C38.3891 93.3759 38.4193 92.8665 38.1182 92.6083L37.1216 91.754C37.0258 91.6718 36.9581 91.5571 36.9291 91.4275L36.6276 90.0803C36.5365 89.6732 36.1005 89.4944 35.7756 89.7309L34.7004 90.5135C34.597 90.5888 34.4743 90.6255 34.3513 90.618L33.0729 90.5394Z"
          fill="#1FE4FF"
        />
        <path
          d="M24.3831 12.4445C23.206 12.3721 22.2927 13.5875 22.5985 14.8195L23.6102 18.8963C23.7076 19.2885 23.6827 19.7073 23.5394 20.088L22.0506 24.0447C21.6007 25.2404 22.3648 26.5364 23.5438 26.5772L27.4452 26.7122C27.8205 26.7252 28.179 26.8722 28.4652 27.1305L31.4403 29.8153C32.3393 30.6267 33.7248 30.2122 34.1477 29.0055L35.5471 25.0121C35.6818 24.6279 35.9282 24.3 36.2484 24.0789L39.5759 21.7815C40.5814 21.0873 40.6736 19.5352 39.756 18.7486L36.7195 16.1455C36.4273 15.8951 36.2212 15.5454 36.1328 15.1505L35.2143 11.0458C34.9367 9.80535 33.6082 9.26055 32.6182 9.98115L29.3421 12.3657C29.0269 12.5952 28.653 12.707 28.2782 12.684L24.3831 12.4445Z"
          fill="#FFE925"
        />
        <path
          d="M50.4166 86.4151C50.0785 86.3943 49.8161 86.7434 49.904 87.0973L50.1946 88.2684C50.2226 88.3811 50.2154 88.5014 50.1743 88.6108L49.7466 89.7474C49.6173 90.0909 49.8368 90.4632 50.1755 90.4749L51.2963 90.5137C51.4041 90.5174 51.5071 90.5596 51.5893 90.6338L52.4439 91.4051C52.7022 91.6382 53.1002 91.5191 53.2217 91.1725L53.6237 90.0253C53.6624 89.9149 53.7331 89.8207 53.8251 89.7572L54.781 89.0973C55.0698 88.8978 55.0963 88.452 54.8327 88.226L53.9605 87.4782C53.8765 87.4063 53.8173 87.3058 53.7919 87.1924L53.5281 86.0133C53.4483 85.6569 53.0667 85.5004 52.7823 85.7074L51.8412 86.3924C51.7506 86.4583 51.6432 86.4905 51.5356 86.4838L50.4166 86.4151Z"
          fill="#FF258E"
        />
        <path
          d="M141.871 27.9052C140.46 27.8185 139.366 29.2752 139.732 30.7518L140.945 35.6381C141.062 36.1083 141.032 36.6102 140.86 37.0665L139.076 41.8088C138.536 43.242 139.452 44.7952 140.865 44.8441L145.541 45.006C145.991 45.0215 146.421 45.1977 146.764 45.5073L150.33 48.7253C151.407 49.6977 153.068 49.201 153.575 47.7546L155.252 42.9683C155.413 42.5078 155.709 42.1148 156.092 41.8498L160.081 39.0963C161.286 38.2642 161.396 36.4039 160.297 35.4611L156.657 32.3411C156.307 32.041 156.06 31.6218 155.954 31.1485L154.853 26.2288C154.52 24.7421 152.928 24.0891 151.741 24.9528L147.815 27.8108C147.437 28.0858 146.989 28.2199 146.54 28.1922L141.871 27.9052Z"
          fill="#1FE4FF"
        />
        <path
          d="M109.789 113.019C109.451 112.998 109.188 113.347 109.276 113.701L109.567 114.872C109.595 114.985 109.587 115.105 109.546 115.214L109.119 116.351C108.989 116.694 109.209 117.067 109.548 117.078L110.668 117.117C110.776 117.121 110.879 117.163 110.961 117.237L111.816 118.009C112.074 118.242 112.472 118.123 112.594 117.776L112.996 116.629C113.034 116.518 113.105 116.424 113.197 116.361L114.153 115.701C114.442 115.501 114.468 115.055 114.205 114.83L113.333 114.082C113.249 114.01 113.189 113.909 113.164 113.796L112.9 112.617C112.82 112.26 112.439 112.104 112.154 112.311L111.213 112.996C111.123 113.062 111.015 113.094 110.908 113.087L109.789 113.019Z"
          fill="white"
        />
        <path
          d="M132.001 70.042C131.405 69.5071 130.484 69.7655 130.202 70.547L129.269 73.1331C129.179 73.382 129.015 73.5933 128.802 73.7345L126.59 75.2021C125.921 75.6456 125.858 76.6543 126.467 77.1733L128.481 78.8907C128.675 79.0559 128.812 79.285 128.87 79.5426L129.476 82.2197C129.659 83.0287 130.541 83.3937 131.199 82.9329L133.378 81.4082C133.587 81.2615 133.836 81.1917 134.085 81.2097L136.672 81.3967C137.454 81.4532 138.061 80.67 137.86 79.8662L137.192 77.2065C137.127 76.9506 137.144 76.6784 137.24 76.432L138.233 73.8704C138.533 73.0963 138.026 72.2473 137.243 72.2114L134.652 72.0923C134.403 72.0808 134.165 71.9823 133.975 71.812L132.001 70.042Z"
          fill="#FF3C11"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4528_37447"
          x="0.705473"
          y="6.4545"
          width="163.557"
          height="114.879"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.60234" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4528_37447"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4528_37447"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  inProgressCircle: (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40.5" cy="40" r="37.5" stroke="#F2F2F2" strokeWidth="5" />
      <path
        d="M25.5 40L35.5028 50L55.5 30"
        stroke="#F49E0B"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  errorCircle: (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40.5" cy="40" r="37.5" stroke="#F2F2F2" strokeWidth="5" />
      <path
        d="M28.7783 54.6566L26 51.8783L37.55 40.3283L26 28.7783L28.7783 26L40.3283 37.55L51.8783 26L54.6566 28.7783L43.1066 40.3283L54.6566 51.8783L51.8783 54.6566L40.3283 43.1066L28.7783 54.6566Z"
        fill="#FF424E"
      />
    </svg>
  ),
  delivery: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="map/subway-fill" clipPath="url(#clip0_1262_22118)">
        <g id="Group 1000001770">
          <path
            id="Rectangle 3468839"
            d="M2.73633 5.40234C2.73633 4.57392 3.4079 3.90234 4.23633 3.90234H12.2067C12.4246 3.90234 12.6013 4.07901 12.6013 4.29694V13.7673H3.52553C3.08966 13.7673 2.73633 13.414 2.73633 12.9781V5.40234Z"
            fill="#F34E86"
          />
          <path
            id="Rectangle 3468840"
            d="M13.0947 5.87549L15.7132 5.87549C15.9308 5.87549 16.1388 5.96534 16.2879 6.1238L20.0002 10.0681V12.9783C20.0002 13.4141 19.6469 13.7675 19.211 13.7675H13.0947V5.87549Z"
            fill="#F34E86"
          />
          <path
            id="Rectangle 3468841"
            d="M15.3163 7.74958C15.3163 7.53165 15.493 7.35498 15.7109 7.35498L17.4472 7.35498L19.3038 9.32797L16.1055 9.32797C15.6697 9.32797 15.3163 8.97464 15.3163 8.53878V7.74958Z"
            fill="white"
          />
          <circle
            id="Ellipse 11"
            cx="16.5474"
            cy="13.7672"
            r="1.87686"
            fill="white"
            stroke="#F0286C"
            strokeWidth="0.907576"
          />
          <circle
            id="Ellipse 12"
            cx="7.17537"
            cy="13.7672"
            r="1.87686"
            fill="white"
            stroke="#F0286C"
            strokeWidth="0.907576"
          />
          <rect
            id="Rectangle 3468842"
            y="8.48975"
            width="5.47233"
            height="1.677"
            rx="0.789197"
            fill="#F0286C"
          />
          <rect
            id="Rectangle 3468843"
            x="0.952148"
            y="6.36865"
            width="3.01217"
            height="1.46975"
            rx="0.734875"
            fill="#F0286C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1262_22118">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  noProduct: (
    <svg
      width="93"
      height="125"
      viewBox="0 0 93 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_948_16067)">
        <path
          d="M89.3498 121.35L85.1624 120.844V110.999L89.3498 110.494C89.6971 110.463 90.0188 110.298 90.2465 110.033C90.4742 109.769 90.59 109.427 90.5693 109.079C90.5487 108.73 90.3932 108.404 90.1358 108.169C89.8785 107.933 89.5396 107.807 89.191 107.818H10.5722C8.42691 107.818 6.36913 108.668 4.84998 110.183C3.33083 111.698 2.47424 113.753 2.46802 115.898C2.46802 118.048 3.32184 120.109 4.84167 121.629C6.3615 123.149 8.42284 124.003 10.5722 124.003H89.191C89.5143 123.978 89.8177 123.837 90.0451 123.606C90.2725 123.375 90.4084 123.069 90.4278 122.746C90.4472 122.422 90.3486 122.102 90.1504 121.846C89.9522 121.589 89.6678 121.413 89.3498 121.35Z"
          fill="#FF9F41"
        />
        <path
          d="M87.9735 121.256H45.1237C43.709 121.256 42.3522 120.694 41.3519 119.694C40.3515 118.694 39.7896 117.337 39.7896 115.922C39.7896 114.507 40.3515 113.151 41.3519 112.15C42.3522 111.15 43.709 110.588 45.1237 110.588H87.9735V121.256Z"
          fill="white"
        />
        <path
          d="M78.9461 113.034H60.9734"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.7073 115.922H48.8052"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M74.6293 118.562H68.3718"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.3498 94.033L85.1624 93.5273V83.6823L89.3498 83.1765C89.6971 83.1456 90.0188 82.9805 90.2465 82.7163C90.4742 82.4521 90.59 82.1096 90.5693 81.7615C90.5487 81.4133 90.3932 81.0869 90.1358 80.8515C89.8785 80.6161 89.5396 80.4902 89.191 80.5006H10.5722C8.42691 80.5006 6.36913 81.3512 4.84998 82.8659C3.33083 84.3807 2.47424 86.436 2.46802 88.5813C2.46802 90.7306 3.32184 92.7919 4.84167 94.3118C6.3615 95.8316 8.42284 96.6854 10.5722 96.6854H89.191C89.5143 96.6608 89.8177 96.52 90.0451 96.2889C90.2725 96.0578 90.4084 95.7522 90.4278 95.4285C90.4472 95.1049 90.3486 94.7852 90.1504 94.5287C89.9522 94.2721 89.6678 94.096 89.3498 94.033Z"
          fill="#1162FF"
        />
        <path
          d="M87.9735 93.9391H45.1237C43.709 93.9391 42.3522 93.3771 41.3519 92.3768C40.3515 91.3764 39.7896 90.0196 39.7896 88.6049C39.7896 87.1902 40.3515 85.8334 41.3519 84.8331C42.3522 83.8327 43.709 83.2708 45.1237 83.2708H87.9735V93.9391Z"
          fill="white"
        />
        <path
          d="M78.9461 85.7173H60.9734"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.7073 88.6047H48.8052"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M74.6293 91.2454H68.3718"
          stroke="#260D0C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.92573 98.4674L9.74866 98.8085V105.454L6.92573 105.795C6.69572 105.822 6.48451 105.935 6.33551 106.112C6.18652 106.289 6.11105 106.517 6.1246 106.748C6.13815 106.979 6.2397 107.196 6.40838 107.355C6.57706 107.514 6.80007 107.601 7.03159 107.601H81.4042C82.8548 107.601 84.246 107.024 85.2717 105.999C86.2974 104.973 86.8736 103.582 86.8736 102.131C86.8736 100.681 86.2974 99.2896 85.2717 98.2638C84.246 97.2381 82.8548 96.6619 81.4042 96.6619H7.03159C6.80007 96.6611 6.57706 96.7491 6.40838 96.9077C6.2397 97.0663 6.13815 97.2834 6.1246 97.5145C6.11105 97.7457 6.18652 97.9732 6.33551 98.1504C6.48451 98.3276 6.69572 98.441 6.92573 98.4674Z"
          fill="#00AB56"
        />
        <g clipPath="url(#clip1_948_16067)">
          <path
            d="M37.0768 75.6263C37.2941 75.6364 37.5121 75.6433 37.7279 75.6461"
            stroke="#0F172A"
            stroke-miterlimit="10"
          />
          <path
            d="M39.0381 75.6055C44.3124 75.2422 49.39 72.469 50.9766 68.0629C54.4794 58.3493 44.0325 49.6673 48.3408 38.5134C52.4506 27.8732 63.9748 30.1227 68.1059 32.8515C72.6676 35.8674 69.6401 40.2964 65.2728 38.4493C57.7017 35.2488 55.0842 25.2423 61.4579 16.3942C66.2201 9.78425 73.922 8.87224 76.9743 8.78295"
            stroke="#0F172A"
            stroke-miterlimit="10"
            stroke-dasharray="4 4"
          />
          <path
            d="M77.6292 8.7763C78.045 8.77775 78.2803 8.79613 78.2803 8.79613"
            stroke="#0F172A"
            stroke-miterlimit="10"
          />
          <path
            d="M83.7622 8.36483C83.6359 5.61639 77.9998 5.08208 78.1637 8.67556C78.3275 12.269 83.8878 11.1165 83.7622 8.36483Z"
            fill="#0F172A"
          />
          <path
            d="M75.955 5.18705C76.2941 4.08557 78.0452 3.6373 80.0926 4.60855C82.14 5.57979 83.7684 7.59678 83.7684 7.59678C83.7684 7.59678 81.2933 8.33553 79.0537 7.99315C76.8141 7.65076 75.6167 6.28533 75.955 5.18705Z"
            fill="#EBEBEB"
          />
          <path
            d="M83.7702 7.59036C82.6526 7.29091 81.5468 6.96025 80.4418 6.62638C79.3369 6.29251 78.2348 5.93535 77.1444 5.54697C78.262 5.84643 79.3718 6.17473 80.4768 6.5086C81.5817 6.84247 82.6838 7.19963 83.7702 7.59036Z"
            fill="#0F172A"
          />
          <path
            d="M78.3831 4.77586C78.9349 5.25408 79.4315 5.79401 79.8635 6.38551C79.5865 6.14913 79.3246 5.89531 79.0791 5.62554C78.8309 5.35642 78.5984 5.07271 78.3831 4.77586Z"
            fill="#0F172A"
          />
          <path
            d="M80.9951 6.7334C80.2982 7.05042 79.5701 7.29081 78.8236 7.45041C79.5237 7.13361 80.255 6.89406 81.0046 6.73594L80.9951 6.7334Z"
            fill="#0F172A"
          />
          <path
            d="M81.4878 6.19537C81.7648 6.43608 81.9824 6.73905 82.1236 7.08046C81.9848 6.96143 81.861 6.82555 81.7549 6.67585C81.648 6.52667 81.5584 6.36547 81.4878 6.19537Z"
            fill="#0F172A"
          />
          <path
            d="M76.2418 12.3252C76.6789 13.3838 78.4624 13.635 80.4087 12.4452C82.355 11.2555 83.8035 9.06996 83.8035 9.06996C83.8035 9.06996 81.2643 8.59575 79.0748 9.17739C76.8854 9.75904 75.8024 11.2625 76.2418 12.3252Z"
            fill="#EBEBEB"
          />
          <path
            d="M83.8035 9.06996C82.7224 9.46754 81.6478 9.94241 80.576 10.394C79.5042 10.8456 78.4453 11.3247 77.3993 11.8313C78.4804 11.4337 79.5542 10.9621 80.6228 10.5096C81.6915 10.0572 82.744 9.5764 83.8035 9.06996Z"
            fill="#0F172A"
          />
          <path
            d="M78.6953 12.45C78.9475 12.1838 79.1843 11.9031 79.4045 11.6092C79.6273 11.315 79.8318 11.0072 80.0169 10.6875C79.7643 10.9533 79.5274 11.234 79.3077 11.5283C79.0861 11.8233 78.8816 12.1311 78.6953 12.45Z"
            fill="#0F172A"
          />
          <path
            d="M81.1245 10.2283C80.3966 9.99026 79.6451 9.83154 78.8829 9.75478C79.2448 9.87582 79.6138 9.97469 79.9878 10.0509C80.3629 10.1317 80.7425 10.191 81.1245 10.2283Z"
            fill="#0F172A"
          />
          <path
            d="M81.6488 10.7089C81.7756 10.5732 81.8863 10.423 81.9785 10.2613C82.0715 10.1011 82.1466 9.93106 82.2024 9.75427C81.9495 10.0267 81.7602 10.353 81.6488 10.7089Z"
            fill="#0F172A"
          />
          <path
            d="M83.7623 8.36483C83.5682 8.37585 83.3758 8.32829 83.2093 8.22817C83.0428 8.12805 82.9097 7.97987 82.8269 7.8024C82.7441 7.62494 82.7154 7.42616 82.7443 7.23125C82.7732 7.03634 82.8585 6.85406 82.9893 6.7075C83.1201 6.56094 83.2906 6.45668 83.4792 6.40793C83.6678 6.35919 83.866 6.36814 84.0487 6.43367C84.2314 6.49919 84.3904 6.61834 84.5055 6.77602C84.6206 6.9337 84.6867 7.12282 84.6954 7.31943C84.7071 7.58229 84.6154 7.83991 84.4405 8.03585C84.2656 8.2318 84.0217 8.3501 83.7623 8.36483Z"
            fill="#455A64"
          />
          <path
            d="M83.8527 10.3511C83.6588 10.3619 83.4666 10.3142 83.3003 10.2141C83.134 10.114 83.0011 9.96595 82.9184 9.78864C82.8357 9.61134 82.8069 9.41276 82.8356 9.21801C82.8644 9.02326 82.9495 8.84108 83.08 8.69451C83.2106 8.54794 83.3808 8.44355 83.5691 8.39454C83.7575 8.34554 83.9555 8.35411 84.1382 8.41919C84.3208 8.48426 84.4799 8.6029 84.5954 8.76013C84.7108 8.91735 84.7774 9.1061 84.7867 9.3025C84.7929 9.43299 84.7737 9.56363 84.7301 9.68696C84.6865 9.81029 84.6194 9.92389 84.5326 10.0213C84.4459 10.1187 84.3412 10.1979 84.2246 10.2545C84.1079 10.3111 83.9815 10.3439 83.8527 10.3511Z"
            fill="#455A64"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_948_16067">
          <rect
            width="93"
            height="124"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_948_16067">
          <rect
            width="29"
            height="80"
            fill="white"
            transform="translate(57.7056 -1.5) rotate(15)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  back: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="black" fill-opacity="0.15" />
      <path
        d="M19.3114 24L11.5 16L19.3114 8L20.5 9.23703L13.8965 16L20.5 22.7629L19.3114 24Z"
        fill="white"
      />
    </svg>
  ),
  backHome: (
    <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.81137 16.9248L0 8.9248L7.81137 0.924805L9 2.16184L2.39649 8.9248L9 15.6878L7.81137 16.9248Z" fill="white"/>
    </svg>

  ),
  homeProduct: (
    <svg
      width="41"
      height="32"
      viewBox="0 0 41 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="-0.000976562"
        width="40.002"
        height="32.002"
        rx="16"
        fill="black"
        fillOpacity="0.15"
      />
      <g clipPath="url(#clip0_309_13800)">
        <path
          d="M25.998 14.1655V21.5022C25.998 21.8993 25.8499 22.2802 25.5862 22.561C25.3224 22.8418 24.9647 22.9996 24.5918 22.9996H15.4041C15.0311 22.9996 14.6734 22.8418 14.4097 22.561C14.146 22.2802 13.9978 21.8993 13.9978 21.5022V14.1655C13.9978 13.933 14.0486 13.7037 14.1463 13.4958C14.2439 13.2879 14.3857 13.1071 14.5603 12.9676L19.1542 9.29904C19.3976 9.10465 19.6936 8.99957 19.9979 8.99957C20.3022 8.99957 20.5983 9.10465 20.8417 9.29904L25.4355 12.9676C25.6102 13.1071 25.7519 13.2879 25.8496 13.4958C25.9472 13.7037 25.998 13.933 25.998 14.1655V14.1655Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.897 22.9997V21.0282C21.897 20.4921 21.697 19.978 21.341 19.5989C20.9851 19.2198 20.5023 19.0068 19.9988 19.0067V19.0067C19.7495 19.0067 19.5027 19.059 19.2723 19.1606C19.042 19.2622 18.8328 19.4111 18.6565 19.5988C18.4802 19.7865 18.3404 20.0094 18.245 20.2546C18.1497 20.4999 18.1006 20.7627 18.1006 21.0282V22.9997"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9986 11.8189L27.499 14.7121"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4995 12.2192L12.4994 14.615"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_309_13800">
          <rect
            width="16.002"
            height="16.002"
            fill="white"
            transform="matrix(-1 0 0 1 28.002 7.99902)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  order: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2162 16.2234H8.99622"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2162 12.0369H8.99622"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7513 7.86011H8.99631"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4086 2.74982C16.4086 2.74982 8.73161 2.75382 8.71961 2.75382C5.95961 2.77082 4.25061 4.58682 4.25061 7.35682V16.5528C4.25061 19.3368 5.97261 21.1598 8.75661 21.1598C8.75661 21.1598 16.4326 21.1568 16.4456 21.1568C19.2056 21.1398 20.9156 19.3228 20.9156 16.5528V7.35682C20.9156 4.57282 19.1926 2.74982 16.4086 2.74982Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  orderActive: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.691 2H8.31C5.27 2 3.5 3.78 3.5 6.83V17.16C3.5 20.26 5.27 22 8.31 22H16.691C19.78 22 21.5 20.26 21.5 17.16V6.83C21.5 3.78 19.78 2 16.691 2Z"
        fill="#3264FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57996 6.65V6.66C8.14896 6.66 7.79996 7.01 7.79996 7.44C7.79996 7.87 8.14896 8.22 8.57996 8.22H11.569C12 8.22 12.35 7.87 12.35 7.429C12.35 7 12 6.65 11.569 6.65H8.57996ZM16.42 12.74H8.57996C8.14896 12.74 7.79996 12.39 7.79996 11.96C7.79996 11.53 8.14896 11.179 8.57996 11.179H16.42C16.85 11.179 17.2 11.53 17.2 11.96C17.2 12.39 16.85 12.74 16.42 12.74ZM16.42 17.31H8.57996C8.27996 17.35 7.98996 17.2 7.82996 16.95C7.66996 16.69 7.66996 16.36 7.82996 16.11C7.98996 15.85 8.27996 15.71 8.57996 15.74H16.42C16.819 15.78 17.12 16.12 17.12 16.53C17.12 16.929 16.819 17.27 16.42 17.31Z"
        fill="#99B2FF"
      />
    </svg>
  ),
  home: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7009 9.94808V18.2175C19.7009 18.6651 19.5231 19.0943 19.2066 19.4109C18.8901 19.7274 18.4608 19.9052 18.0132 19.9052H6.98688C6.53927 19.9052 6.10999 19.7274 5.79349 19.4109C5.47698 19.0943 5.29917 18.6651 5.29917 18.2175V9.94808C5.29917 9.68607 5.36017 9.42766 5.47735 9.19331C5.59452 8.95897 5.76464 8.75512 5.97425 8.59791L11.4874 4.46303C11.7796 4.24393 12.1349 4.12549 12.5 4.12549C12.8652 4.12549 13.2205 4.24393 13.5127 4.46303L19.0258 8.59791C19.2355 8.75512 19.4056 8.95897 19.5228 9.19331C19.6399 9.42766 19.7009 9.68607 19.7009 9.94808V9.94808Z"
        stroke="#64748B"
        strokeWidth="1.50018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7781 19.9052V17.6831C14.7781 17.0789 14.5381 16.4994 14.1109 16.0721C13.6837 15.6449 13.1043 15.4048 12.5 15.4047V15.4047C12.2009 15.4047 11.9046 15.4636 11.6282 15.5781C11.3518 15.6926 11.1006 15.8605 10.8891 16.072C10.6776 16.2836 10.5098 16.5348 10.3953 16.8112C10.2809 17.0876 10.222 17.3839 10.222 17.6831V19.9052"
        stroke="#64748B"
        strokeWidth="1.50018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3001 7.30363L21.501 10.5647"
        stroke="#64748B"
        strokeWidth="1.50018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.09961 7.75408L3.49917 10.4544"
        stroke="#64748B"
        strokeWidth="1.50018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  homeActive: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3199 16.0429C11.9155 16.0439 11.5278 16.205 11.2418 16.491C10.9558 16.777 10.7947 17.1646 10.7937 17.5691V20.5429H13.8499V17.5691C13.8488 17.1641 13.6871 16.776 13.4003 16.4899C13.1135 16.2038 12.725 16.0431 12.3199 16.0429Z"
        fill="#99B2FF"
      />
      <path
        d="M22.3981 9.73597L19.8405 7.81881L18.6266 6.90737L14.0341 3.45805C13.5903 3.12891 13.0524 2.95121 12.4999 2.95121C11.9474 2.95121 11.4096 3.12891 10.9658 3.45805L6.99006 6.4438L5.19469 7.78974C5.07517 7.87676 4.9658 7.97691 4.86862 8.08831L2.59002 9.85619C2.42591 9.98456 2.31903 10.1724 2.29255 10.3791C2.26608 10.5858 2.32215 10.7945 2.44859 10.9601C2.52274 11.0549 2.61757 11.1314 2.72584 11.1838C2.83411 11.2362 2.95294 11.2632 3.07324 11.2626C3.24713 11.2638 3.41623 11.2056 3.55253 11.0976L4.17325 10.6144V18.4952C4.17387 19.1723 4.44312 19.8214 4.92187 20.3002C5.40063 20.7789 6.04978 21.0482 6.72684 21.0488H9.32759V17.9334C9.32853 17.0929 9.66285 16.287 10.2572 15.6926C10.8516 15.0983 11.6574 14.764 12.498 14.763C13.3391 14.7631 14.1459 15.0971 14.741 15.6915C15.3362 16.2859 15.6711 17.0922 15.6723 17.9334V21.0488H18.277C18.9538 21.0474 19.6025 20.778 20.0811 20.2994C20.5597 19.8208 20.8292 19.172 20.8306 18.4952V10.524L21.4552 10.9916C21.5911 11.0938 21.7566 11.149 21.9266 11.1487C22.0486 11.1487 22.1689 11.1203 22.278 11.0658C22.3871 11.0112 22.482 10.932 22.5552 10.8344C22.6175 10.7522 22.6629 10.6584 22.6888 10.5585C22.7146 10.4586 22.7204 10.3546 22.7058 10.2524C22.6912 10.1503 22.6565 10.052 22.6036 9.96337C22.5508 9.87473 22.4809 9.79744 22.3981 9.73597Z"
        fill="#3264FF"
      />
    </svg>
  ),
  cart: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92229 19.8203C8.34429 19.8203 8.68729 20.1633 8.68729 20.5853C8.68729 21.0073 8.34429 21.3493 7.92229 21.3493C7.50029 21.3493 7.15829 21.0073 7.15829 20.5853C7.15829 20.1633 7.50029 19.8203 7.92229 19.8203Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1747 19.8203C19.5967 19.8203 19.9397 20.1633 19.9397 20.5853C19.9397 21.0073 19.5967 21.3493 19.1747 21.3493C18.7527 21.3493 18.4097 21.0073 18.4097 20.5853C18.4097 20.1633 18.7527 19.8203 19.1747 19.8203Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.24991 3.25L5.32991 3.61L6.29291 15.083C6.37091 16.018 7.15191 16.736 8.08991 16.736H19.0019C19.8979 16.736 20.6579 16.078 20.7869 15.19L21.7359 8.632C21.8529 7.823 21.2259 7.099 20.4089 7.099H5.66391"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6254 10.795H17.3984"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cartActive: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6213 11.2331H17.3891C17.8088 11.2331 18.1386 10.8861 18.1386 10.4677C18.1386 10.0391 17.8088 9.70236 17.3891 9.70236H14.6213C14.2016 9.70236 13.8719 10.0391 13.8719 10.4677C13.8719 10.8861 14.2016 11.2331 14.6213 11.2331ZM20.6766 5.92749C21.2861 5.92749 21.6858 6.1418 22.0855 6.61123C22.4852 7.08067 22.5551 7.7542 22.4652 8.36549L21.5159 15.06C21.3361 16.3469 20.2569 17.2949 18.9879 17.2949H8.08639C6.75742 17.2949 5.65828 16.255 5.54837 14.908L4.62908 3.7834L3.12026 3.51807C2.72057 3.44664 2.44079 3.04864 2.51073 2.64043C2.58068 2.22305 2.97038 1.94649 3.38006 2.00874L5.7632 2.3751C6.10293 2.43735 6.35274 2.72207 6.38272 3.06905L6.57257 5.35499C6.60254 5.68257 6.86234 5.92749 7.18209 5.92749H20.6766ZM7.92631 18.9079C7.08697 18.9079 6.4075 19.6018 6.4075 20.459C6.4075 21.3061 7.08697 22 7.92631 22C8.75567 22 9.43514 21.3061 9.43514 20.459C9.43514 19.6018 8.75567 18.9079 7.92631 18.9079ZM19.1676 18.9079C18.3282 18.9079 17.6487 19.6018 17.6487 20.459C17.6487 21.3061 18.3282 22 19.1676 22C19.9969 22 20.6764 21.3061 20.6764 20.459C20.6764 19.6018 19.9969 18.9079 19.1676 18.9079Z"
        fill="#99B2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3891 11.2331H14.6213C14.2016 11.2331 13.8719 10.8861 13.8719 10.4677C13.8719 10.0391 14.2016 9.70236 14.6213 9.70236H17.3891C17.8088 9.70236 18.1386 10.0391 18.1386 10.4677C18.1386 10.8861 17.8088 11.2331 17.3891 11.2331ZM22.0855 6.61123C21.6858 6.1418 21.2861 5.92749 20.6766 5.92749H7.18209C6.86234 5.92749 6.60254 5.68257 6.57257 5.35499L6.38272 3.06905C6.35274 2.72207 6.10293 2.43735 5.7632 2.3751L3.38006 2.00874C2.97038 1.94649 2.58068 2.22305 2.51073 2.64043C2.44079 3.04864 2.72057 3.44664 3.12026 3.51807L4.62908 3.7834L5.54837 14.908C5.65828 16.255 6.75742 17.2949 8.08639 17.2949H18.9879C20.2569 17.2949 21.3361 16.3469 21.5159 15.06L22.4652 8.36549C22.5551 7.7542 22.4852 7.08067 22.0855 6.61123Z"
        fill="#3264FF"
      />
    </svg>
  ),
  bubble: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.59 12.26C18.4232 12.26 20.72 9.96323 20.72 7.13C20.72 4.29678 18.4232 2 15.59 2C12.7567 2 10.46 4.29678 10.46 7.13C10.46 9.96323 12.7567 12.26 15.59 12.26Z"
        fill="#FFC700"
      />
      <path
        d="M6.36026 19.44C8.0613 19.44 9.44028 18.061 9.44028 16.36C9.44028 14.659 8.0613 13.28 6.36026 13.28C4.65922 13.28 3.28027 14.659 3.28027 16.36C3.28027 18.061 4.65922 19.44 6.36026 19.44Z"
        fill="#BDCC19"
      />
      <path
        d="M16.6196 22C18.0334 22 19.1796 20.8539 19.1796 19.44C19.1796 18.0262 18.0334 16.88 16.6196 16.88C15.2057 16.88 14.0596 18.0262 14.0596 19.44C14.0596 20.8539 15.2057 22 16.6196 22Z"
        fill="#006CB7"
      />
    </svg>
  ),
  addCartFree: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#F49E0B" />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.59473 18.2385C7.59473 17.6063 8.10651 17.0945 8.7387 17.0945C9.36337 17.0945 9.87515 17.6063 9.87515 18.2385C9.87515 18.8632 9.36337 19.375 8.7387 19.375C8.10651 19.375 7.59473 18.8632 7.59473 18.2385ZM16.0618 18.2385C16.0618 17.6063 16.5735 17.0945 17.2057 17.0945C17.8304 17.0945 18.3422 17.6063 18.3422 18.2385C18.3422 18.8632 17.8304 19.375 17.2057 19.375C16.5735 19.375 16.0618 18.8632 16.0618 18.2385Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.341 7.52188C18.8001 7.52188 19.1012 7.67993 19.4022 8.02613C19.7033 8.37234 19.7559 8.86906 19.6882 9.31988L18.9732 14.257C18.8378 15.2061 18.0249 15.9053 17.0691 15.9053H8.85807C7.85709 15.9053 7.02921 15.1376 6.94643 14.1449L6.25402 5.94064L5.11757 5.74496C4.81652 5.69227 4.60579 5.39875 4.65848 5.09771C4.71116 4.78914 5.00468 4.58593 5.31325 4.63109L7.10824 4.90203C7.36413 4.94794 7.55228 5.15792 7.57486 5.41381L7.71786 7.09967C7.74044 7.34125 7.93612 7.52188 8.17695 7.52188H18.341ZM13.7803 11.4347H15.865C16.1811 11.4347 16.4295 11.1789 16.4295 10.8703C16.4295 10.5542 16.1811 10.3058 15.865 10.3058H13.7803C13.4642 10.3058 13.2158 10.5542 13.2158 10.8703C13.2158 11.1789 13.4642 11.4347 13.7803 11.4347Z"
        fill="white"
      />
    </svg>
  ),
  addCart: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#3264FF" />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.59473 18.2385C7.59473 17.6063 8.10651 17.0945 8.7387 17.0945C9.36337 17.0945 9.87515 17.6063 9.87515 18.2385C9.87515 18.8632 9.36337 19.375 8.7387 19.375C8.10651 19.375 7.59473 18.8632 7.59473 18.2385ZM16.0618 18.2385C16.0618 17.6063 16.5735 17.0945 17.2057 17.0945C17.8304 17.0945 18.3422 17.6063 18.3422 18.2385C18.3422 18.8632 17.8304 19.375 17.2057 19.375C16.5735 19.375 16.0618 18.8632 16.0618 18.2385Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.341 7.52188C18.8001 7.52188 19.1012 7.67993 19.4022 8.02613C19.7033 8.37234 19.7559 8.86906 19.6882 9.31988L18.9732 14.257C18.8378 15.2061 18.0249 15.9053 17.0691 15.9053H8.85807C7.85709 15.9053 7.02921 15.1376 6.94643 14.1449L6.25402 5.94064L5.11757 5.74496C4.81652 5.69227 4.60579 5.39875 4.65848 5.09771C4.71116 4.78914 5.00468 4.58593 5.31325 4.63109L7.10824 4.90203C7.36413 4.94794 7.55228 5.15792 7.57486 5.41381L7.71786 7.09967C7.74044 7.34125 7.93612 7.52188 8.17695 7.52188H18.341ZM13.7803 11.4347H15.865C16.1811 11.4347 16.4295 11.1789 16.4295 10.8703C16.4295 10.5542 16.1811 10.3058 15.865 10.3058H13.7803C13.4642 10.3058 13.2158 10.5542 13.2158 10.8703C13.2158 11.1789 13.4642 11.4347 13.7803 11.4347Z"
        fill="white"
      />
    </svg>
  ),
  cartDisable: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#EFF2F8" />
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.59473 18.2387C7.59473 17.6065 8.10651 17.0947 8.7387 17.0947C9.36337 17.0947 9.87515 17.6065 9.87515 18.2387C9.87515 18.8634 9.36337 19.3752 8.7387 19.3752C8.10651 19.3752 7.59473 18.8634 7.59473 18.2387ZM16.0618 18.2387C16.0618 17.6065 16.5735 17.0947 17.2057 17.0947C17.8304 17.0947 18.3422 17.6065 18.3422 18.2387C18.3422 18.8634 17.8304 19.3752 17.2057 19.3752C16.5735 19.3752 16.0618 18.8634 16.0618 18.2387Z"
        fill="#C8CBD4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.341 7.52182C18.8001 7.52182 19.1012 7.67987 19.4022 8.02607C19.7033 8.37228 19.7559 8.869 19.6882 9.31982L18.9732 14.257C18.8378 15.206 18.0249 15.9052 17.0691 15.9052H8.85807C7.85709 15.9052 7.02921 15.1375 6.94643 14.1448L6.25402 5.94058L5.11757 5.7449C4.81652 5.69221 4.60579 5.39869 4.65848 5.09765C4.71116 4.78907 5.00468 4.58587 5.31325 4.63103L7.10824 4.90197C7.36413 4.94788 7.55228 5.15786 7.57486 5.41375L7.71786 7.0996C7.74044 7.34119 7.93612 7.52182 8.17695 7.52182H18.341ZM13.7803 11.4347H15.865C16.1811 11.4347 16.4295 11.1788 16.4295 10.8702C16.4295 10.5541 16.1811 10.3058 15.865 10.3058H13.7803C13.4642 10.3058 13.2158 10.5541 13.2158 10.8702C13.2158 11.1788 13.4642 11.4347 13.7803 11.4347Z"
        fill="#C8CBD4"
      />
    </svg>
  ),
  arrowUp: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9.99207L8 4L14 9.99207L12.9762 11L8 6.03034L3.02377 11L2 9.99207Z"
        fill="black"
      />
    </svg>
  ),
  arrowLeft: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9998 19.92L8.47984 13.4C7.70984 12.63 7.70984 11.37 8.47984 10.6L14.9998 4.07996"
        stroke="white"
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1262_18565)">
        <path
          d="M6 18L18 6"
          stroke="#0F172A"
          strokeWidth="1.6"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M18 18L6 6"
          stroke="#0F172A"
          strokeWidth="1.6"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1262_18565">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  highlight: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#FFC845" fill-opacity="0.08" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6398 10.8682C17.7872 11.4182 18.3588 11.7447 18.9139 11.596C19.1938 11.521 19.4813 11.6852 19.5556 11.9626L20.0405 13.7722C20.4505 15.3024 19.5278 16.8838 17.9835 17.2976L10.0624 19.4201C8.51808 19.8339 6.92758 18.9259 6.51756 17.3957L6.03268 15.5861C5.95836 15.3087 6.12523 15.0227 6.40515 14.9477C6.96095 14.7988 7.2927 14.2302 7.14531 13.6802C7.0017 13.1442 6.46022 12.857 5.88617 13.0108C5.75161 13.0469 5.60896 13.0284 5.48831 12.9595C5.36767 12.8905 5.27996 12.7769 5.24442 12.6442L4.74509 10.7753C4.33508 9.24511 5.25764 7.66302 6.80196 7.24922L14.721 5.12732C16.2653 4.71352 17.856 5.62219 18.266 7.1524L18.7518 8.96247C18.7873 9.09513 18.7684 9.23808 18.6988 9.35724C18.6288 9.47725 18.5145 9.5646 18.3793 9.60083C17.8242 9.74957 17.4924 10.3181 17.6398 10.8682ZM14.0309 12.304L14.622 11.3213C14.725 11.1515 14.7206 10.943 14.612 10.7782C14.504 10.6133 14.314 10.5263 14.119 10.5505L12.9749 10.6862L12.217 9.82941C12.0869 9.68188 11.8868 9.62205 11.6952 9.67265L11.6939 9.67301C11.5032 9.7241 11.3598 9.87598 11.3196 10.0692L11.0918 11.1908L10.0349 11.6441C9.85211 11.7219 9.73107 11.8922 9.71936 12.0892C9.70833 12.286 9.80875 12.4688 9.98223 12.5645L10.9855 13.12L11.0889 14.2577C11.1067 14.454 11.233 14.6198 11.4185 14.69C11.5231 14.7288 11.6338 14.7336 11.7373 14.7058C11.8164 14.6846 11.8909 14.6438 11.9537 14.5861L12.8021 13.8087L13.923 14.057C14.1176 14.1018 14.316 14.0335 14.4407 13.8795C14.5671 13.7264 14.5936 13.5197 14.5109 13.3408L14.0309 12.304Z"
        fill="#FF9800"
      />
    </svg>
  ),
  ticked: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#3264FF" fillOpacity="0.08" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6398 10.8682C17.7872 11.4182 18.3588 11.7447 18.9139 11.596C19.1938 11.521 19.4813 11.6852 19.5556 11.9626L20.0405 13.7722C20.4505 15.3024 19.5278 16.8838 17.9835 17.2976L10.0624 19.4201C8.51808 19.8339 6.92758 18.9259 6.51756 17.3957L6.03268 15.5861C5.95836 15.3087 6.12523 15.0227 6.40515 14.9477C6.96095 14.7988 7.2927 14.2302 7.14531 13.6802C7.0017 13.1442 6.46022 12.857 5.88617 13.0108C5.75161 13.0469 5.60896 13.0284 5.48831 12.9595C5.36767 12.8905 5.27996 12.7769 5.24442 12.6442L4.74509 10.7753C4.33508 9.24511 5.25764 7.66302 6.80196 7.24922L14.721 5.12732C16.2653 4.71352 17.856 5.62219 18.266 7.1524L18.7518 8.96247C18.7873 9.09513 18.7684 9.23808 18.6988 9.35724C18.6288 9.47725 18.5145 9.5646 18.3793 9.60083C17.8242 9.74957 17.4924 10.3181 17.6398 10.8682ZM14.0309 12.304L14.622 11.3213C14.725 11.1515 14.7206 10.943 14.612 10.7782C14.504 10.6133 14.314 10.5263 14.119 10.5505L12.9749 10.6862L12.217 9.82941C12.0869 9.68188 11.8868 9.62205 11.6952 9.67265L11.6939 9.67301C11.5032 9.7241 11.3598 9.87598 11.3196 10.0692L11.0918 11.1908L10.0349 11.6441C9.85211 11.7219 9.73107 11.8922 9.71936 12.0892C9.70833 12.286 9.80875 12.4688 9.98223 12.5645L10.9855 13.12L11.0889 14.2577C11.1067 14.454 11.233 14.6198 11.4185 14.69C11.5231 14.7288 11.6338 14.7336 11.7373 14.7058C11.8164 14.6846 11.8909 14.6438 11.9537 14.5861L12.8021 13.8087L13.923 14.057C14.1176 14.1018 14.316 14.0335 14.4407 13.8795C14.5671 13.7264 14.5936 13.5197 14.5109 13.3408L14.0309 12.304Z"
        fill="#3264FF"
      />
    </svg>
  ),
  bookmark: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#3264FF" fillOpacity="0.08" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.77779 19.0003L9.14387 19.0003C10.1309 19.0003 10.9219 18.1953 10.9219 17.2075L10.9219 14.8212C10.9219 13.8271 10.1309 13.0291 9.14387 13.0291L6.77779 13.0291C5.79775 13.0291 4.99973 13.8271 4.99973 14.8212L4.99973 17.2075C4.99973 18.1953 5.79775 19.0003 6.77779 19.0003ZM17.2222 19.0003L14.8561 19.0003C13.8691 19.0003 13.078 18.1953 13.078 17.2075L13.078 14.8211C13.078 13.8271 13.8691 13.0291 14.8561 13.0291L17.2222 13.0291C18.2022 13.0291 19.0002 13.8271 19.0002 14.8211L19.0002 17.2075C19.0002 18.1953 18.2022 19.0003 17.2222 19.0003ZM17.2222 10.9712L14.8562 10.9712C13.8691 10.9712 13.0781 10.1725 13.0781 9.17847L13.0781 6.79209C13.0781 5.80506 13.8691 5.00003 14.8562 5.00003L17.2222 5.00003C18.2023 5.00003 19.0003 5.80506 19.0003 6.79209L19.0003 9.17847C19.0003 10.1725 18.2023 10.9712 17.2222 10.9712ZM9.14387 10.9712L6.77779 10.9712C5.79775 10.9712 4.99973 10.1725 4.99973 9.17847L4.99973 6.79209C4.99973 5.80506 5.79775 5.00003 6.77779 5.00003L9.14387 5.00003C10.1309 5.00003 10.9219 5.80506 10.9219 6.79209L10.9219 9.17847C10.9219 10.1725 10.1309 10.9712 9.14387 10.9712Z"
        fill="#3264FF"
      />
    </svg>
  ),
  arrowRight: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.15" />
      <path
        d="M12 18L10.9676 16.9492L15.1987 12.7285H6V11.2715H15.1987L10.9676 7.0404L12 6L18 12L12 18Z"
        fill="white"
      />
    </svg>
  ),
  recommend: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#3264FF" fillOpacity="0.08" />
      <path
        d="M11.9976 20C11.6264 20 11.295 19.9154 11.0036 19.7463C10.7121 19.5771 10.5226 19.3384 10.4351 19.03H10.1514C9.80454 19.0143 9.50551 18.8785 9.25427 18.6225C9.00304 18.3665 8.87743 18.0707 8.87743 17.735V14.9792C7.98259 14.4008 7.27931 13.6678 6.76758 12.7802C6.25586 11.8926 6 10.911 6 9.8354C6 8.21594 6.58287 6.83851 7.7486 5.70312C8.91435 4.56771 10.3303 4 11.9964 4C13.6625 4 15.0797 4.56771 16.2478 5.70312C17.4159 6.83851 18 8.21594 18 9.8354C18 10.9118 17.7433 11.8938 17.23 12.7816C16.7166 13.6693 16.0142 14.4019 15.1226 14.9792V17.735C15.1226 18.0707 14.9961 18.3665 14.7433 18.6225C14.4904 18.8785 14.1922 19.0143 13.8486 19.03H13.5649C13.4742 19.3383 13.2822 19.5771 12.9892 19.7463C12.6961 19.9154 12.3655 20 11.9976 20ZM10.258 17.735H13.7372V16.8682H10.258V17.735ZM10.258 16.0802H13.7372V15.2922H10.258V16.0802ZM12.4927 14.0678V11.4208L14.3666 9.599L13.6997 8.95063L11.9976 10.6054L10.2954 8.95063L9.62849 9.599L11.5024 11.4208V14.0678H12.4927Z"
        fill="#3264FF"
      />
    </svg>
  ),
  bag: (
    <svg
      width="75"
      height="84"
      viewBox="0 0 75 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.8718 21.2201C58.0032 20.9247 58.0647 20.6029 58.0518 20.2797H58.1597C57.6976 9.16134 48.5938 0.386719 37.5204 0.386719C26.447 0.386719 17.3432 9.16134 16.8811 20.2797C16.8267 20.5908 16.8267 20.909 16.8811 21.2201H16.5581C11.2631 21.2201 5.60283 24.7449 3.95953 34.2204L0.745975 60.0315C-1.8833 78.9823 7.79389 83.72 20.429 83.72H54.6826C67.2812 83.72 76.6662 76.8598 74.3291 60.0315L71.1521 34.2204C69.2166 25.0102 63.739 21.2201 58.517 21.2201H57.8718ZM51.9338 21.2201C51.8188 20.9198 51.7578 20.6014 51.7538 20.2797C51.7538 12.2902 45.3088 5.81332 37.3585 5.81332C29.4082 5.81332 22.9632 12.2902 22.9632 20.2797C23.0176 20.5908 23.0176 20.909 22.9632 21.2201H51.9338ZM25.505 42.6724C23.4882 42.6724 21.8532 40.9755 21.8532 38.8823C21.8532 36.789 23.4882 35.0921 25.505 35.0921C27.5218 35.0921 29.1567 36.789 29.1567 38.8823C29.1567 40.9755 27.5218 42.6724 25.505 42.6724ZM45.7723 38.8823C45.7723 40.9755 47.4072 42.6724 49.424 42.6724C51.4409 42.6724 53.0758 40.9755 53.0758 38.8823C53.0758 36.789 51.4409 35.0921 49.424 35.0921C47.4072 35.0921 45.7723 36.789 45.7723 38.8823Z"
        fill="#64748B"
        fillOpacity="0.15"
      />
    </svg>
  ),
  goTo: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#3264FF" fill-opacity="0.08" />
      <path
        d="M12 18L10.9676 16.9492L15.1987 12.7285H6V11.2715H15.1987L10.9676 7.0404L12 6L18 12L12 18Z"
        fill="#3264FF"
      />
    </svg>
  ),
  tagPolicy: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill="#3264FF" fill-opacity="0.08" />
      <path
        d="M16.5732 10.2493L12.9121 6.48535C12.1879 5.74093 11.2654 5.23397 10.261 5.02859C9.25663 4.8232 8.21558 4.92862 7.26949 5.33151C6.3234 5.73439 5.51476 6.41665 4.94583 7.29201C4.37691 8.16737 4.07324 9.19651 4.07324 10.2493C4.07324 11.3021 4.37691 12.3312 4.94583 13.2066C5.51476 14.0819 6.3234 14.7642 7.26949 15.1671C8.21558 15.57 9.25663 15.6754 10.261 15.47C11.2654 15.2646 12.1879 14.7576 12.9121 14.0132L16.5732 10.2493Z"
        fill="#3264FF"
      />
    </svg>
  ),
};
